export const DEFAULT_TITLE = 'bg.head_widget.default_title';
